import React from 'react';
import { Grid } from '@mui/material';

import { Typography, InfoField, Card, CardHeader, CardContent } from '@occc-app/design-system';
import { Limit_Time_Period, LimitFragment } from '@occc/graphql';

type TimePeriodMap = {
  [key in Limit_Time_Period]: string;
};
type FormatLimitInTime = (limit: { limit: number; timePeriod: Limit_Time_Period }) => string;
type FormatLimit = (limit: { limit: number }) => string;

const timePeriodMap: TimePeriodMap = {
  [Limit_Time_Period.Day]: 'day',
  [Limit_Time_Period.Week]: 'week',
  [Limit_Time_Period.Month]: 'month',
};
const formatActivationLimitInTime: FormatLimitInTime = ({ limit, timePeriod }) =>
  `${limit} activations per ${timePeriodMap[timePeriod]}`;

const formatAwardLimitInTime: FormatLimitInTime = ({ limit, timePeriod }) =>
  `${limit} fulfillments per ${timePeriodMap[timePeriod]}`;

const formatActivationLimit: FormatLimit = ({ limit }) => `${limit} activations`;
const formatAwardLimit: FormatLimit = ({ limit }) => `${limit} fulfillments`;
const formatProgressLimit: FormatLimit = ({ limit }) => `${limit} progress TBD`;
const formatProgressInTimeLimit: FormatLimit = ({ limit }) => `${limit} progress in time TBD`;
const formatTransactionCountTotal: FormatLimit = ({ limit }) => `${limit} transactions total`;
const formatTransactionCountInTime: FormatLimitInTime = ({ limit, timePeriod }) =>
  `${limit} transactions per ${timePeriodMap[timePeriod]}`;

const textFieldDataMapLimit = {
  LimitGlobalActivation: {
    label: 'Global Activation Limit',
    format: formatActivationLimit,
  },
  LimitMembershipActivation: {
    label: 'Membership Activation Limit',
    format: formatActivationLimit,
  },
  LimitGlobalAwardCount: {
    label: 'Global Award Count',
    format: formatAwardLimit,
  },
  LimitMembershipAwardCount: {
    label: 'Membership Award Count',
    format: formatAwardLimit,
  },
  LimitInTransactionAwardCount: {
    label: 'Membership in Transaction Award Count',
    format: formatAwardLimit,
  },
  LimitInTransactionProgress: {
    label: 'Membership in Transaction Progress',
    format: formatProgressLimit,
  },
  LimitMembershipTransactionCount: {
    label: 'Membership Transaction Count',
    format: formatTransactionCountTotal,
  },
};

const textFieldDataMapLimitInTime = {
  LimitGlobalActivationInTime: {
    label: 'Global Activation Limit in Time',
    format: formatActivationLimitInTime,
  },
  LimitMembershipActivationInTime: {
    label: 'Membership Activation Limit in Time',
    format: formatActivationLimitInTime,
  },
  LimitGlobalAwardCountInTime: {
    label: 'Global Award Count in Time',
    format: formatAwardLimitInTime,
  },
  LimitMembershipAwardCountInTime: {
    label: 'Membership Award Count in Time',
    format: formatAwardLimitInTime,
  },
  LimitMembershipProgressInTime: {
    label: 'Membership Progress in Time',
    format: formatProgressInTimeLimit,
  },
  LimitMembershipTransactionCountInTime: {
    label: 'Membership Transaction Count',
    format: formatTransactionCountInTime,
  },
};

type LimitsProps = {
  limits: LimitFragment[];
};

export const Limits: React.FC<LimitsProps> = ({ limits }) => (
  <Card>
    <CardHeader
      title={
        <Typography variant='h6' component='h4' gutterBottom>
          Limits
        </Typography>
      }
    />
    <CardContent>
      <Grid container spacing={2}>
        {limits.map((limit, index) => {
          // TODO: think about more elegant solution of data defining
          const data =
            'timePeriod' in limit
              ? textFieldDataMapLimitInTime[limit.__typename]
              : textFieldDataMapLimit[limit.__typename];

          return (
            <Grid item md={3} key={index}>
              <InfoField label={data.label} value={data.format(limit)} />
            </Grid>
          );
        })}
      </Grid>
    </CardContent>
  </Card>
);
